enum States {
  INITIAL,
  LOADING,
  ERROR,
  LOADED,
  COMPLETED,
  ERRORUPDATE,
  ERRORLOADING,
  SUCCESSUPDATE
}
export default States;
